<i18n src="../../lib/i18n/product/locales.json"></i18n>

<template>
    <Row>
        <navbar :transparent="isTransparent"></navbar>
        <div class="ichat">
            <div class="ichat_main_page">
                <div class="detail_slide_1" ref="mybox">
                    <div style="position:absolute;top:40%;left: 0;right:0;bottom:0;">
                        <i-col span="24">
                            <div class="ichat_banner_title">iChat</div>
                            <p class="details_banner_text">
                                {{$t('ichat_details_page_title')}}
                            </p>
                            <p class="details_banner_text">
                                {{$t('ichat_details_page_title1')}}
                            </p>
                        </i-col>
                    </div>
                </div>
                <div class="layout-content" style="z-index: 1;">
                    <div class="Product-content mogos">
                        <div class="Product-content" style="background: #FFFFFF;padding:10% 0 10% 0;">
                            <Row style="padding:0 3% 0 3%">
                                <Col class="Product-left" :md="13" style="text-align: center;">
                                <img src="../../assets/store/ichat.png" class="mogos-logo">
                                </Col>
                                <Col class="Product-right" :md="11" style="text-align: left;">
                                <p class="Product-name">
                                    {{$t('ichat_details_page_product_title')}}
                                </p>
                                <p class="Product-price">
                                    ${{goods_info.goods_price}}
                                </p>
                                <p class="Product-details">
                                    {{$t('ichat_details_page_product_content')}}
                                </p>
                                <ul>
                                    <li class="Product-details-li">{{$t('ichat_details_page_product_parameters1')}}</li>
                                    <li class="Product-details-li">{{$t('ichat_details_page_product_parameters2')}}</li>
                                    <li class="Product-details-li">{{$t('ichat_details_page_product_parameters3')}}</li>
                                </ul>
                                <buy :id="parseInt($route.query.id)"
                                     :maxCount="parseInt(goods_info.store_count)"></buy>
                                </Col>
                            </Row>
                        </div>

                        <div class="Product-content speedy">
                            <div style="background:rgba(31,45,61,0.3);padding:25px 0 25px 0;">
                                <Row style="" :gutter="30" class="details-card">
                                    <Col :xs="24" :sm="12" :md="10" :lg="8" class="details_card_text">
                                    <Card style="background: rgba(31,45,61,0.40);border:none;color:#fff;">
                                        <div style="text-align:center">
                                            <img src="../../assets/store/ichat_icon1.png">
                                            <span style="display: block;">{{$t('ichat_details_page_advantage1_content1_1')}}</span>
                                            <span style="display: block;">{{$t('ichat_details_page_advantage1_content1_2')}}</span>
                                        </div>
                                    </Card>
                                    </Col>
                                    <Col :xs="24" :sm="12" :md="10" :lg="8" class="details_card_text">
                                    <Card style="background: rgba(31,45,61,0.40);border:none;color:#fff;">
                                        <div style="text-align:center">
                                            <img src="../../assets/store/ichat_icon2.png">
                                            <span style="display: block;">{{$t('ichat_details_page_advantage1_content2_1')}}</span>
                                            <span style="display: block;">{{$t('ichat_details_page_advantage1_content2_2')}}</span>
                                        </div>
                                    </Card>
                                    </Col>
                                    <Col :xs="24" :sm="12" :md="10" :lg="8" class="details_card_text">
                                    <Card style="background: rgba(31,45,61,0.40);border:none;color:#fff;">
                                        <div style="text-align:center">
                                            <img src="../../assets/store/ichat_icon3.png">
                                            <span style="display: block;">{{$t('ichat_details_page_advantage1_content3_1')}}</span>
                                            <span style="display: block;">{{$t('ichat_details_page_advantage1_content3_2')}}</span>
                                        </div>
                                    </Card>
                                    </Col>

                                    <i-col :xs="24" :sm="12" :md="10" :lg="8" class="details_card_text">
                                        <Card style="background: rgba(31,45,61,0.40);border:none;color:#fff;">
                                            <div style="text-align:center">
                                                <img src="../../assets/store/ichat_icon4.png">
                                                <span style="display: block;">{{$t('ichat_details_page_advantage1_content4_1')}}</span>
                                                <span style="display: block;">{{$t('ichat_details_page_advantage1_content4_2')}}</span>
                                            </div>
                                        </Card>
                                    </i-col>
                                    <i-col :xs="24" :sm="12" :md="10" :lg="8" class="details_card_text">
                                        <Card style="background: rgba(31,45,61,0.40);border:none;color:#fff;">
                                            <div style="text-align:center">
                                                <img src="../../assets/store/ichat_icon5.png">
                                                <span style="display: block;">{{$t('ichat_details_page_advantage1_content5_1')}}</span>
                                                <span style="display: block;">{{$t('ichat_details_page_advantage1_content5_2')}}</span>
                                            </div>
                                        </Card>
                                    </i-col>
                                    <i-col :xs="24" :sm="12" :md="10" :lg="8" class="details_card_text">
                                        <Card style="background: rgba(31,45,61,0.40);border:none;color:#fff;">
                                            <div style="text-align:center">
                                                <img src="../../assets/store/ichat_icon6.png">
                                                <span style="display: block;">{{$t('ichat_details_page_advantage1_content6_1')}}</span>
                                                <span style="display: block;">{{$t('ichat_details_page_advantage1_content6_2')}}</span>
                                            </div>
                                        </Card>
                                    </i-col>
                                </Row>
                            </div>
                        </div>

                        <div class="details_iapp_banner">
                            <i-col span="24">
                                <div class="layout-conten" id="ichat_phone">
                                    <div class="swiper-container">
                                        <i-col :xs="24" :sm="{span:24,offset:0}" :md="{span:12,offset:11}"
                                               :lg="{span:12,offset:11}" style="position: absolute;top: 0;">
                                            <p class="details_iapp_text details_iapp_text1">
                                                {{$t('iglobal_details_advantage2')}}
                                            </p>
                                            <p class="details_iapp_text details_iapp_text2">
                                                {{$t('mogos_details_page_advantage2_content')}}
                                            </p>
                                        </i-col>
                                        <div class="swiper-wrapper">
                                            <div id="slider1" class="swiper-slide slider1" style="position: relative;">
                                            </div>
                                            <div id="slider2" class="swiper-slide slider2">
                                            </div>
                                            <div id="slider3" class="swiper-slide slider3">
                                            </div>
                                        </div>
                                        <!-- Add Pagination -->
                                        <div class="swiper-pagination">
                                        </div>
                                        <i-col span="12" offset="12">
                                            <p class="details_iapp_text"
                                               style="font-size: 40px;color: #1F2D3D;line-height: 78px;">
                                                {{$t('mogos_details_page_advantage2')}}
                                            </p>
                                            <p class="details_iapp_text"
                                               style="font-size: 22px;color: #5E6D82;line-height: 40px;">
                                                $t('mogos_details_page_advantage2_content')}}
                                            </p>
                                        </i-col>
                                    </div>
                                </div>
                                <div class="mobile-ichat-phone"  style="display: none">
                                    <p class="details_iapp_text details_iapp_text1">
                                        {{$t('mogos_details_page_advantage2')}}
                                    </p>
                                    <p class="details_iapp_text details_iapp_text2">
                                        {{$t('mogos_details_page_advantage2_content')}}
                                    </p>
                                    <div class="ichat-step">
                                        <p class="Product-smname">1.{{$t('ichat_step_3')}}</p>
                                        <img src="../../assets/store/ichat_phone2_en.jpg" alt="iglobal-step-1" v-if="this.mogosLang=='en' ">
                                        <img src="../../assets/store/ichat_phone2.png" alt="iglobal-step-1" v-else-if="this.mogosLang=='cn' ">
                                    </div>
                                    <div class="ichat-step">
                                        <p class="Product-smname">2.{{$t('ichat_step_1')}}</p>
                                        <img src="../../assets/store/mogos_phone_en.png" alt="iglobal-step-2" v-if="this.mogosLang=='en' ">
                                        <img src="../../assets/store/mogos_phone2.png" alt="iglobal-step-1" v-else-if="this.mogosLang=='cn' ">
                                    </div>
                                    <div class="ichat-step">
                                        <p class="Product-smname">3.{{$t('ichat_step_2')}}</p>
                                        <img src="../../assets/store/ichat_phone3_en.jpg" alt="iglobal-step-3" v-if="this.mogosLang=='en' ">
                                        <img src="../../assets/store/ichat_phone3.jpg" alt="iglobal-step-1" v-else-if="this.mogosLang=='cn' ">
                                    </div>
                                </div>
                            </i-col>
                        </div>
                        <div style="clear: both"></div>
                        <div class="Product-content detials_purchase" style="padding:10% 0 10% 0">
                            <Row>
                                <i-col class="Product-right"  style="text-align: left;max-width: 1200px;margin: 0 auto;">
                                    <p class="Product-name" style="color:#fff;">
                                        {{$t('ichat_details_page_advantage2')}}
                                    </p>
                                    <div class="Product-details" style="color:#fff;margin-top:30px;">
                                        <p>{{$t('ichat_details_page_advantage2_content1')}}</p>
                                        <p>{{$t('ichat_details_page_advantage2_content2')}}</p>
                                    </div>
                                    <button class="Product-btn" style="color:#fff;background-color:#ccc;border: none"
                                            @click="buyNow">
                                        {{$t('buy_now')}}
                                    </button>
                                </i-col>
                            </Row>
                        </div>
                        <div class="igo-product-details-footer">
                            <p style="color: #0084ff;">{{$t('shopping_notes')}}</p>
                            <p>{{$t('shopping_notes_tip')}}</p>
                        </div>
                        <div class="detail-basis max_width">
                            <guess></guess>
                        </div>

                    </div>
                </div>
            </div>
        </div>
        <BackTop>
            <div class="top">
                <img src="../../assets/backtop/top.png">
                <p style="">{{$t('top_btn')}}</p>
            </div>
        </BackTop>
        <a href="http://ifree.ly/support" target="_blank">
            <BackTop :height="100" :bottom="110">
                <div class="top">
                    <img src="../../assets/backtop/service.png">
                    <p>{{$t('Service_btn')}}</p>
                </div>
            </BackTop>
        </a>
    </Row>
</template>
<script>
    import Swiper from '../../../static/js/swiper-3.4.2.min'
    import navbar from '../Common/Navbar.vue'
    import buy from '../Common/Buy.vue'
    import guess from '../Profiler/Common/Guess.vue'
    import Signature from '../../lib/Signature'

    export default {
        data () {
            return {
                value1: 0,
                minus_text: 1,
                scroll: '',
                active: false,
                num: 1,
                goods_info: {},
                isTransparent:true,
                mogosLang:'cn'

            }
        },
        components: {
            navbar, buy, guess
        },
        created () {
            let module = 'index.php/index/goods/goodsinfo'
            let data = {}
            data.sub_time = Signature.timestamp()
            data.sign = Signature.create(module, data.sub_time)
            data.user_id = this.Local.getUserId()
            data.token = this.Local.getUserToken()
            data.lang = this.$config.defaults.l
            data.goods_id = this.$route.query.id
            this.$http.get(process.env.BASEURL + module, {
                params: data
            }).then(function (resp) {
                if (parseInt(resp.data.code) === 2000) {
                    this.goods_info = resp.data.data.goods_info
                }
            }.bind(this))
        },
        mounted () {
            window.addEventListener('scroll', this.init)
            var swiper = new Swiper('.swiper-container', {
                pagination: '.swiper-pagination',
                paginationClickable: true,
                direction: 'vertical',
                loop: false,
                speed: 1000,
                autoplay: false,
                mousewheelReleaseOnEdges: false,
                mousewheelControl: false,
                effect: 'fade',
                fade: {
                    crossFade: true,
                },
                onTouchEnd: function () {
                    swiper.startAutoplay()
                }
            })
            $('.swiper-pagination span:nth-of-type(1)').html("<p><span>1</span>"+this.$t('ichat_step_3')+"</p>")
            $('.swiper-pagination span:nth-of-type(2)').html("<p><span>2</span>"+this.$t('ichat_step_1')+"</p>")
            $('.swiper-pagination span:nth-of-type(3)').html("<p><span>3</span>"+this.$t('ichat_step_2')+"</p>")


            this.lang = this.$i18n.locale
            if (this.lang === 'en-US') {
                $("#slider1").removeClass("slider1")
                $("#slider1").addClass("slider1_en")
                $("#slider2").removeClass("slider2")
                $("#slider2").addClass("slider2_en")
                $("#slider3").removeClass("slider3")
                $("#slider3").addClass("slider3_en")
                this.mogosLang = 'en'
            }else{
                this.mogoLang = 'cn'
            }

        },
        methods: {
            addShopCart (count) {
                this.addToCart(count)
            },
            tab (index) {
                this.num = index
            },
            buyNow () {
                this.$router.push({
                    name: 'Settlement',
                    query: {
                        goods_id: 2,
                        number: 1
                    }
                })
            },
        }

    }
</script>
<style lang="scss">
    @import '../../assets/css/swiper-3.4.2.min.css';

    .ichat {
        perspective: 1px;
        padding: 0;
        height: 100%;
        overflow: auto;
        .detail_slide_1 {
            height: 100vh;
            max-height: 760px;
            background: url("../../assets/store/ichat_pic1.jpg") no-repeat center;
            background-size: cover;
            position: relative;
            overflow: hidden;
            .ichat_banner_title {
                font-size: 120px;
                color: #FFFFFF;
            }
        }

        .speedy {
            background: url('../../assets/store/ichat_pic2.jpg') no-repeat center;
            background-size: cover;

        }

        .details_banner_text {
            /*font-family: PingFangSC-Semibold;*/
            font-size: 22px;
            color: #FFFFFF;
            letter-spacing: 0;
            line-height: 40px;
            margin-top:-15px;
        }
        .Product-details-li {
            font-size: 16px;
            color: #5E6D82;
        }
        .mogos {
            position: relative;
        }

        .Product-name {
            font-size: 32px;
            color: #1F2D3D;
            line-height: 45px;
            padding-top: 20px;
        }

        .Product-price {
            font-size: 32px;
            color: #0084ff;
            line-height: 26px;
            margin: 3% 0 3% 0;
        }

        .Product-details {
            /*font-family: Roboto-Regular;*/
            font-size: 16px;
            color: #5E6D82;
            letter-spacing: 0;
            line-height: 22px;
            padding: 0 20% 2% 0;
        }

        .Product-btn {
            border: 1px solid #0084FF;
            border-radius: 5px;
            height: 50px;
            width: 200px;
            font-size: 20px;
            color: #0084FF;
            background: transparent;
            margin: 2% 6% 0% 0%;
        }

        .Product-btn:hover {
            background: #0084FF;
            color: white;
            /*font-weight: 600;*/
        }

        .Product-more {
            font-size: 16px;
        }

        .details_card_text {
            margin: 15px 0;
            .ivu-card-body{
                img{
                    margin-bottom: 10px;
                }
            }
        }

        .details_card_text div {
            /*font-family: PingFangSC-Regular;*/
            font-size: 16px;
            letter-spacing: 0;
            line-height: 24px;
            border-radius: 0 !important;
            padding: 15px 0;
        }
        .detail_country {
            margin-bottom: 5%;
        }

        .detail-button {
            margin-top: 12%;
        }
        #ichat_phone{
            height:700px;
            background:#FFF;
        }

        /*backtop*/
        .swiper-container {
            width: 100%;
            height: 100%;
        }

        .swiper-slide {
            color: white;
            text-align: center;
            font-size: 18px;
            background: #fff;
            /* Center slide text vertically */
            display: -webkit-box;
            display: -ms-flexbox;
            display: -webkit-flex;
            display: flex;
            -webkit-box-pack: center;
            -ms-flex-pack: center;
            -webkit-justify-content: center;
            justify-content: center;
            -webkit-box-align: center;
            -ms-flex-align: center;
            -webkit-align-items: center;
            align-items: center;
        }

        /*slider-main-page*/
        .details_iapp_banner {
            height: 100vh;
            padding: 8% 0;
            max-width: 1300px;
            margin: 0 auto;
        }

        .details_iapp_text {
            /*font-family: PingFangSC-Regular;*/
            letter-spacing: 0;
        }

        .details_iapp_text1 {
            font-size: 32px;
            color: #1F2D3D;
            line-height: 55px;
        }

        .details_iapp_text2 {
            font-size: 20px;
            color: #5E6D82;
            line-height: 40px;
        }

        .details_iapp_banner .slider1_en {
            background: url('../../assets/store/mogos_phone_en.png');
            background-repeat: no-repeat;
            background-position: 20%;
            background-size: contain;
        }

        .details_iapp_banner .slider2_en {
            background: url('../../assets/store/ichat_phone2_en.jpg');
            background-repeat: no-repeat;
            background-position: 20%;
            background-size: contain;
        }

        .details_iapp_banner .slider3_en {
            background: url('../../assets/store/ichat_phone3_en.jpg');
            background-repeat: no-repeat;
            background-position: 20%;
            background-size: contain;
        }

        .details_iapp_banner .slider1 {
            background: url('../../assets/store/mogos_phone2.png');
            background-repeat: no-repeat;
            background-position: 20%;
            background-size: contain;
        }

        .details_iapp_banner .slider2 {
            background: url('../../assets/store/ichat_phone2.jpg');
            background-repeat: no-repeat;
            background-position: 20%;
            background-size: contain;
        }

        .details_iapp_banner .slider3 {
            background: url('../../assets/store/ichat_phone3.jpg');
            background-repeat: no-repeat;
            background-position: 20%;
            background-size: contain;
        }

        .details_iapp_banner .swiper-pagination-bullet {
            background: white;
        }

        .details_iapp_banner .swiper-container-vertical > .swiper-pagination-bullets {
            right: 35%;
            top: 35%;
        }

        .details_iapp_banner .swiper-pagination-bullet {
            width: 16px;
            height: 16px;
            font-size: 16px;
            margin-top: 2% !important;
            /*background: url("../../assets/store/.png") center;*/
            background-size: 100% 100%;
        }

        .details_iapp_banner .swiper-main {
            width: 35%;
            text-align: left;
            position: absolute;
            left: 50%;
        }

        .details_iapp_banner .swiper-main-title {
            margin: -15% 0 5% 0;
            font-size: 3em;
        }

        .details_iapp_banner .swiper-main-page {
            font-size: 17px;
            line-height: 26px;
        }

        .swiper-container-vertical > .swiper-pagination-bullets .swiper-pagination-bullet {
            margin: 20px 0;
        }

        .swiper-pagination span p {
            /*font-family: PingFangSC-Regular;*/
            width: 600px;
            text-align: left;
            line-height: 24px;
        }

        .swiper-pagination span p span {
            margin: 0 40px 0 5px;
            color: #fff;
            font-size: 14px;
        }

        .details_iapp_banner .swiper-pagination-bullet-active {
            background: url("../../assets/store/selected_right.png") center;
            background-size: 100% 100%;
            border-radius: 0 !important;
            width: 32px;
            height: 100%;
            color: #0084ff !important;
            font-size: 18px !important;
        }

        .details_global {
            color: #0084ff;
            border: 1px solid #0084ff;
            width: 120px;
            margin: 2%;
            font-size: 14px;
            background-color: #fff;
        }

        .details_global_active {
            color: #fff;
            background-color: #0084ff;
        }

        .details_global_active:hover {
            color: #fff;
            background-color: #0084ff;
        }

        .detials_purchase {
            background: url("../../assets/store/ichat_pic3.jpg") center;
            background-size: cover;
            background-repeat: no-repeat;
        }

        /*滚动条*/

        .Product-tips {
            /*font-family: PingFangSC-Regular;*/
            font-size: 32px;
            color: #FFFFFF;
            letter-spacing: 0;
            line-height: 78px;
            margin: 50px 0 20px 0;
        }

        .details-card {
            max-width: 1024px;
            width: 100%;
            margin: 10px auto !important;
            padding: 8% 0 8% 0;
        }

        .igo-product-details-footer{
            text-align: left;
            width: 100%;
            max-width: 1200px;
            margin: 0 auto;
            padding: 30px 10px;
            /*font-family: PingFangSC-Regular;*/
            font-size: 16px;
            color: #5E6D82;
        }

        @media screen and (max-width: 992px) {
            .Product-left, .Product-right {
                text-align: center !important;
            }
        }

        @media screen and (max-width: 768px) {
            .details_iapp_banner .swiper-slide {
                background-position: center !important;
                background-size: 45%;
            }
            #ichat_phone{
                height:800px;
                background:#FFF;
            }
            .swiper-pagination-bullet {
                display: none !important;
            }
            #slider1 {
                transform: translate3d(0, 150px, 0px) !important;
            }
            #slider2 {
                transform: translate3d(0, -650px, 0px) !important;
            }
            #slider3 {
                transform: translate3d(0, -1450px, 0px) !important;
            }
            .mogos-logo {
                width: 80%;
            }

            .details_banner_text {
                font-size: 16px;
            }

            .detail_slide_1 {
                .ichat_banner_title {
                    font-size: 45px;
                }
            }
            .Product-tips {
                font-size: 35px;
            }

            .details-card {
                width: 70%;
            }

            .Product-search {
                width: 100% !important;
                font-size: 24px;
            }

            .Product-btn {
                margin: 5% 0 0 0;
            }

            .detail_country {
                background: none;
            }

            .detail-button {
                padding: 100px 0;
            }

            .details_iapp_text1 {
                font-size: 32px;
                color: #1F2D3D;
                line-height: 78px;
            }

            .details_iapp_text2 {
                font-size: 20px;
                color: #5E6D82;
                line-height: 40px;
            }
        }

        @media screen and (max-width: 500px) {
            #ichat_phone{
                display: none;
            }
            .mobile-ichat-phone{
                display: block !important;
            }
            .ichat-step{
                max-width: 300px;
                margin:20px auto;
                p{
                    margin:10px 0;
                    font-size: 16px;
                    color: #0084ff;
                }
                img{
                    width: 90%;
                }
            }
            .detials_purchase{
                height: 100vh;
                background: url("../../assets/home/new_home/ichat_2@2x.jpg") no-repeat ;
                .Product-right{
                    padding-top: 40%;
                }
            }
            .detail_slide_1{
                background: url("../../assets/home/new_home/ichat_1@2x.jpg") no-repeat ;
            }
            .details_iapp_text1{
                font-size: 24px;
                color: #1F2D3D;
                line-height: 45px;
            }
            .details_iapp_text2{
                font-size: 20px;
            }
            .details-card {
                width: 100%;
            }
            .details_card_text div {
                font-size: 14px;
            }
            .Product-tips {
                font-size: 24px;
            }

            .details_iapp_banner .swiper-container-vertical > .swiper-pagination-bullets {
                display: none !important;
            }

            .Product-name {
                font-size: 24px;
            }

            .details_iapp_banner .swiper-slide {
                background-position: center !important;
                background-size: 65%;
            }
            .detials_purchase{
                margin-top: 80px;
            }
        }

        @media screen and (max-width: 1000px) {
            .Product-details {
                padding: 0px 0% 2% 0px;
            }

        }

    }




    ::-webkit-scrollbar {
        width: 0px;
    }
</style>



// WEBPACK FOOTER //
// ichat.vue?5d682c9e